enum QuizzesDataType {
  GET_QUIZZES_DATA_REQUEST = 'quizzes/getQuizzesDataRequest',
  GET_QUIZZES_DATA_REJECTED = 'quizzes/getQuizzesDataRejected',
  GET_QUIZZES_DATA_FULFILLED = 'quizzes/getQuizzesDataFulfilled',
}

export default QuizzesDataType;
